import React from 'react';

const SfxLayerIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M3 17H5V7H3V17ZM7 13H9V11H7V13ZM11 21H13V3H11V21ZM15 19H17V5H15V19ZM19 15H21V9H19V15Z" fill="currentColor"/>
		</svg>
	);
};

export default SfxLayerIcon;
